exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".section-logo[data-v-227ef796] {\n  width: 220px !important;\n  margin: 17px auto 0px;\n}\n@media only screen and (min-device-width: 320px) and (max-device-width: 480px) {\n.section-logo[data-v-227ef796] {\n    width: 170px !important;\n}\n}\n.bg-featured-section[data-v-227ef796] {\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n}", ""]);

// exports
